// @ts-nocheck
import * as React from "react";
import { Logo, supportPhone } from "./common";

// Static policy pages — 개인정보처리방침 / 이용약관
// Shared TOC + reading layout. Linked from footer (common.tsx) and signup consent.

const PRIVACY_TOC = [
  { id: "intro",     label: "1. 총칙" },
  { id: "purpose",   label: "2. 수집·이용 목적" },
  { id: "items",     label: "3. 수집 항목" },
  { id: "retention", label: "4. 보유 기간" },
  { id: "share",     label: "5. 제3자 제공" },
  { id: "trust",     label: "6. 처리위탁" },
  { id: "rights",    label: "7. 정보주체 권리" },
  { id: "security",  label: "8. 안전성 확보 조치" },
  { id: "officer",   label: "9. 개인정보 보호책임자" },
  { id: "change",    label: "10. 변경 이력" },
];

const TERMS_TOC = [
  { id: "purpose",  label: "제1조 (목적)" },
  { id: "def",      label: "제2조 (용어의 정의)" },
  { id: "effect",   label: "제3조 (약관의 효력·개정)" },
  { id: "join",     label: "제4조 (이용계약의 성립)" },
  { id: "id",       label: "제5조 (계정·비밀번호 관리)" },
  { id: "service",  label: "제6조 (서비스 내용)" },
  { id: "duty",     label: "제7조 (회원의 의무)" },
  { id: "stop",     label: "제8조 (서비스 제공의 정지)" },
  { id: "limit",    label: "제9조 (책임의 제한)" },
  { id: "dispute",  label: "제10조 (분쟁 해결)" },
];

function PolicyShell({ kind, title, badge, toc, children }) {
  return (
    <div className="app" style={{background:'var(--bg)', minHeight:'100vh'}}>
      <header style={{padding:'18px 64px', borderBottom:'1px solid var(--border-soft)', background:'var(--surface)', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        <a href="/" style={{textDecoration:'none', color:'inherit'}}><Logo/></a>
        <div style={{display:'flex', gap:18, fontSize:13, color:'var(--ink-2)'}}>
          <a href="/privacy"  style={{color: kind === 'privacy' ? 'var(--orange-600)' : 'inherit', fontWeight: kind === 'privacy' ? 700 : 500, textDecoration:'none'}}>개인정보처리방침</a>
          <a href="/terms"    style={{color: kind === 'terms'   ? 'var(--orange-600)' : 'inherit', fontWeight: kind === 'terms'   ? 700 : 500, textDecoration:'none'}}>이용약관</a>
          <a href="/login"    style={{color:'inherit', textDecoration:'none'}}>로그인</a>
        </div>
      </header>

      <div style={{maxWidth:1100, margin:'0 auto', padding:'56px 32px', display:'grid', gridTemplateColumns:'220px 1fr', gap:48}}>
        <aside style={{position:'sticky', top:32, alignSelf:'start'}}>
          <div style={{fontSize:11, fontWeight:700, color:'var(--orange-700)', letterSpacing:'0.08em', marginBottom:10}}>{badge}</div>
          <nav style={{display:'flex', flexDirection:'column', gap:6}}>
            {toc.map(t => (
              <a key={t.id} href={`#${t.id}`} style={{fontSize:12.5, color:'var(--ink-2)', textDecoration:'none', padding:'6px 10px', borderRadius:8}}>{t.label}</a>
            ))}
          </nav>
          <div style={{marginTop:18, padding:14, background:'var(--bg-sub)', borderRadius:12, fontSize:11.5, color:'var(--ink-3)', lineHeight:1.6}}>
            <div style={{fontWeight:700, color:'var(--ink-2)', marginBottom:4}}>문의</div>
            개인정보 보호책임자<br/>
            support@care.local<br/>
            {supportPhone()} (평일 09:00–18:00)
          </div>
        </aside>

        <main style={{maxWidth:760}}>
          <div style={{fontSize:11, fontWeight:700, color:'var(--orange-700)', letterSpacing:'0.08em', marginBottom:8}}>{badge}</div>
          <h1 style={{fontSize:32, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>{title}</h1>
          <div className="muted" style={{fontSize:12, marginTop:8}}>최종 개정 2026-04-01 · 시행 2026-04-15</div>
          <div style={{marginTop:36, fontSize:14, lineHeight:1.8, color:'var(--ink-2)'}}>
            {children}
          </div>
        </main>
      </div>

      <footer style={{padding:'22px 64px', borderTop:'1px solid var(--border-soft)', background:'var(--surface-2)', fontSize:11, color:'var(--ink-3)', display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:12}}>
        <div>© 2026 통합돌봄</div>
        <div style={{display:'flex', gap:16}}>
          <a href="/privacy" style={{color:'inherit', textDecoration:'none'}}>개인정보처리방침</a>
          <a href="/terms"   style={{color:'inherit', textDecoration:'none'}}>이용약관</a>
          <a href="mailto:support@care.local" style={{color:'inherit', textDecoration:'none'}}>support@care.local</a>
        </div>
      </footer>
    </div>
  );
}

function H2({ id, children }) {
  return <h2 id={id} style={{fontSize:18, fontWeight:800, color:'var(--ink-1)', marginTop:36, marginBottom:10, scrollMarginTop:24}}>{children}</h2>;
}

function P({ children }) { return <p style={{margin:'10px 0', whiteSpace:'pre-line'}}>{children}</p>; }

// 정책 본문만 — 데스크톱 PolicyShell과 모바일 셸이 공유한다. 헤더/사이드바
// (TOC·문의 카드) 같은 데스크톱 chrome은 PolicyShell이 담당하고, 본문 텍스트는
// 여기 한 곳에만 둔다. 모바일 매니저 마이페이지 정책 화면(mobile-manager.tsx)이
// 이 본문을 재사용한다.
function PrivacyBody() {
  return (
    <>

      <P>{`통합돌봄(이하 "회사")은 2026 돌봄통합지원법에 따라 운영하는 통합돌봄 플랫폼(이하 "서비스")을 제공하면서 「개인정보 보호법」, 「의료법」 및 관련 법령을 준수합니다. 본 방침은 회사가 어떤 개인정보를, 어떤 목적으로, 어떻게 처리하는지를 안내합니다.`}</P>

      <H2 id="intro">1. 총칙</H2>
      <P>{`회사는 정보주체의 자유와 권리를 보호하기 위해 개인정보의 처리 및 보호에 관한 사항을 본 방침으로 안내합니다. 본 방침은 회사가 운영하는 모든 서비스(웹·모바일 PWA)에 적용됩니다.`}</P>

      <H2 id="purpose">2. 수집·이용 목적</H2>
      <P>{`① 회원 가입 및 본인 확인
② 케어 신청 접수, AI 매칭 추천, 매니저 배정
③ 방문 일정 관리·기록, 보호자 알림
④ 위험 신호 감지 및 응급 대응
⑤ 법령상 의무 이행(돌봄 기록 보존 등)
⑥ 서비스 개선을 위한 익명 통계 분석`}</P>

      <H2 id="items">3. 수집 항목</H2>
      <P>{`▸ 필수: 성명, 생년월일, 연락처, 이메일, 주소(시·군·구 단위), 자격증 정보(매니저)
▸ 돌봄 관련(민감정보): 건강 상태, 노쇠도, 복용 약물, 보호자 관계, 방문 기록
▸ 자동 수집: 접속 IP, 단말기 정보, 위치(매니저 PWA), 쿠키, 서비스 이용 기록`}</P>

      <H2 id="retention">4. 보유 기간</H2>
      <P>{`▸ 계정 정보: 회원 탈퇴 후 30일 (재가입 부정행위 방지)
▸ 방문·돌봄 기록: 10년 (개인정보보호법, 의료/돌봄 기록 보존 기준)
▸ 감사 로그(권한·승인): 5년
▸ 일반 활동 로그: 90일`}</P>

      <H2 id="share">5. 제3자 제공</H2>
      <P>{`회사는 정보주체의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다:
① 응급 상황에서 119·1391 등 공공 응급 기관
② 법령 또는 수사기관의 요청
③ 사전 동의를 받은 매칭 대상 케어매니저·유관기관`}</P>

      <H2 id="trust">6. 처리위탁</H2>
      <P>{`▸ 클라우드 인프라: Amazon Web Services Korea
▸ 메시지 발송: 카카오엔터프라이즈(알림톡), LG U+(SMS)
모든 수탁자에는 보안서약과 정기 점검을 적용합니다.`}</P>

      <H2 id="rights">7. 정보주체 권리</H2>
      <P>{`정보주체는 언제든지 다음의 권리를 행사할 수 있습니다:
열람, 정정·삭제, 처리정지, 동의 철회, 자기결정권 행사.
요청은 서비스 내 [내 정보] 또는 support@care.local 로 접수해 주시면 30일 이내에 처리합니다.`}</P>

      <H2 id="security">8. 안전성 확보 조치</H2>
      <P>{`▸ 관리적: 정기 보안 교육, 접근권한 분리(역할 기반)
▸ 기술적: 전송·저장 시 암호화(TLS 1.3, AES-256), 비정상 접근 탐지
▸ 물리적: 인증된 데이터센터, 출입 통제
▸ 감사: 모든 주요 행위는 감사 로그에 기록, 정기 외부 감사`}</P>

      <H2 id="officer">9. 개인정보 보호책임자</H2>
      <P>{`성명: 박상우 (시스템 관리자)
연락처: support@care.local · ${supportPhone()}
정보주체는 개인정보 침해에 대해 다음 기관에도 신고하실 수 있습니다:
▸ 개인정보분쟁조정위원회 1833-6972
▸ 개인정보침해신고센터 (privacy.kisa.or.kr) 118
▸ 대검찰청 1301 / 경찰청 182`}</P>

      <H2 id="change">10. 변경 이력</H2>
      <P>{`▸ 2026-04-01 · 본 방침 시행 (2026 돌봄통합지원법 시행에 따른 전면 개정)
▸ 2025-12-10 · 위치정보 수집 항목 추가
▸ 2025-08-05 · 최초 제정`}</P>

    </>
  );
}

function Privacy() {
  return (
    <PolicyShell kind="privacy" title="개인정보처리방침" badge="PRIVACY POLICY" toc={PRIVACY_TOC}>
      <PrivacyBody/>
    </PolicyShell>
  );
}

function TermsBody() {
  return (
    <>

      <P>{`본 약관은 통합돌봄(이하 "회사")이 운영하는 통합돌봄 플랫폼(이하 "서비스")의 이용에 관한 회사와 회원 간의 권리·의무 및 책임사항을 규정합니다.`}</P>

      <H2 id="purpose">제1조 (목적)</H2>
      <P>{`본 약관은 회원이 서비스를 이용함에 있어 회사와 회원 간의 권리, 의무, 책임사항을 규정함을 목적으로 합니다.`}</P>

      <H2 id="def">제2조 (용어의 정의)</H2>
      <P>{`① "회원"이란 본 약관에 동의하고 서비스를 이용하는 자를 말합니다.
② "케어매니저"란 사회복지사, 간호조무사 등 자격을 보유하고 방문 돌봄을 수행하는 회원을 말합니다.
③ "유관기관"이란 병원, 보건소, 소방서, 행정복지센터 등 서비스에 협력하는 기관을 말합니다.
④ "권역 관리자"란 권역 단위로 서비스 운영을 담당하는 회원을 말합니다.
⑤ "보호자"란 어르신과 가족 관계에 있고 어르신을 대신해 서비스를 신청·관리하는 자를 말합니다.`}</P>

      <H2 id="effect">제3조 (약관의 효력·개정)</H2>
      <P>{`① 본 약관은 회원이 동의함으로써 효력이 발생합니다.
② 회사는 필요 시 약관을 개정할 수 있으며, 개정 약관은 시행 7일 전(불리한 변경은 30일 전)부터 공지합니다.
③ 회원이 명시적으로 거부 의사를 표시하지 않은 경우 동의한 것으로 봅니다.`}</P>

      <H2 id="join">제4조 (이용계약의 성립)</H2>
      <P>{`① 이용계약은 회원이 가입 양식을 작성하고 회사가 이를 승낙함으로써 성립합니다.
② 케어매니저·유관기관 가입은 권역 관리자의 자격 검증·승인 후 활성화됩니다.
③ 다음의 경우 회사는 가입을 거부하거나 사후 해지할 수 있습니다: 실명·자격 정보의 허위, 사회질서 위반, 부정 이용 이력.`}</P>

      <H2 id="id">제5조 (계정·비밀번호 관리)</H2>
      <P>{`① 회원은 본인의 계정·비밀번호를 직접 관리할 책임이 있습니다.
② 본인의 계정으로 발생한 모든 활동은 회원 본인의 책임이며, 도용이 의심될 경우 즉시 회사에 알려야 합니다.`}</P>

      <H2 id="service">제6조 (서비스 내용)</H2>
      <P>{`회사는 다음의 서비스를 제공합니다:
▸ 케어 신청 접수, AI 매칭 추천, 매니저 배정
▸ 방문 일정·기록·알림
▸ 권역·기관·매니저 관리, 운영 리포트
▸ 어르신·보호자용 모바일 PWA`}</P>

      <H2 id="duty">제7조 (회원의 의무)</H2>
      <P>{`회원은 다음 행위를 해서는 안 됩니다:
① 타인의 정보 도용
② 허위 정보 입력
③ 회사·타 회원의 권리를 침해하는 행위
④ 서비스의 정상적 운영을 방해하는 행위`}</P>

      <H2 id="stop">제8조 (서비스 제공의 정지)</H2>
      <P>{`회사는 다음의 경우 서비스 제공을 정지할 수 있습니다:
① 시스템 점검·교체·고장
② 천재지변, 정전, 통신두절
③ 회원이 본 약관을 위반한 경우`}</P>

      <H2 id="limit">제9조 (책임의 제한)</H2>
      <P>{`① 회사는 천재지변 또는 불가항력으로 인한 서비스 제공 불가에 대해 책임지지 않습니다.
② 회사는 회원이 입력한 정보의 신뢰성을 보증하지 않으며, AI 매칭 결과는 최종 결정의 보조 수단으로 제공됩니다.
③ 응급 상황에서는 본 서비스가 119 등 공공 응급 체계를 대체할 수 없습니다.`}</P>

      <H2 id="dispute">제10조 (분쟁 해결)</H2>
      <P>{`① 본 약관에 명시되지 않은 사항은 관련 법령과 일반 상관례에 따릅니다.
② 분쟁 발생 시 회사 본사 소재지를 관할하는 법원을 합의 관할로 합니다.
③ 회원은 한국소비자원·전자거래분쟁조정위원회에 조정을 신청할 수 있습니다.`}</P>

    </>
  );
}

function Terms() {
  return (
    <PolicyShell kind="terms" title="이용약관" badge="TERMS OF SERVICE" toc={TERMS_TOC}>
      <TermsBody/>
    </PolicyShell>
  );
}

export { Privacy, Terms, PrivacyBody, TermsBody, PRIVACY_TOC, TERMS_TOC };
